module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand4-21fab9cbf47c03f546a75925a0e78800.jpg";